import React, { createRef } from "react";

import Lottie from "lottie-react";
import animationData from "./Loader.json";

// Redux
import { useSelector } from "react-redux";

//css
import "../assets/css/custom.css";

// MUI
import Dialog from "@material-ui/core/Dialog";
// import { CircularProgress } from "@material-ui/core";

const Spinner = () => {
  const open = useSelector((state) => state.spinner.networkProgressDialog);
  const ref = createRef();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Dialog
      open={open}
      disableBackdropClick
      disableEscapeKeyDown
      PaperComponent="div"
      ref={ref}
      style={{
        background: "transparent",
        boxShadow: "none",
      }}
    >
      <div style={{ width: 130, height: 130 }}>
        <Lottie animationData={animationData} loop={true} autoplay={true} />
      </div>
      {/* <CircularProgress options={defaultOptions}/> */}
    </Dialog>
  );
};

export default React.memo(Spinner);
